import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getSaqueExtrato(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('empresa-financeiro-distribuicao/saque/extrato', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    getExtratoResumo(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('empresa-financeiro-distribuicao/extrato-resumo', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    saque(context, playload) {
      return new Promise((resolve, reject) => {
        axios.post('/empresa-financeiro-distribuicao/saque', playload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    enviarTokenSaque(context, playload) {
      return new Promise((resolve, reject) => {
        axios.post('/empresa-financeiro-distribuicao/saque/enviar-token', playload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
